module.exports = __webpack_public_path__ + "officialStatic/img/about-company.83e4907.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/about-company.png
// module id = L7kE
// module chunks = 0